import { VideoStepType } from "@web-src/modules/workspace/hooks/useWorkspaceFeatureInfo/useWorkspaceFeatureInfo";
import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import spot1 from "./assets/spot-1.png";
import spot2 from "./assets/spot-2.png";
import spot3 from "./assets/spot-3.png";

export const VideoStep = ({ videoUrl }: VideoStepType) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { ref, inView } = useInView({
    threshold: 0.25,
  });

  useEffect(() => {
    if (videoRef.current && !inView) {
      videoRef.current.pause();
    }
  }, [inView]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (videoRef.current && document.hidden) {
        videoRef.current.pause();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <div className="font-secondary relative flex h-[646px] justify-center px-[16px]">
      <div className="relative flex w-full max-w-[100%] items-start justify-center py-10">
        <div
          className="z-20 h-[586px] w-full max-w-[985px] rounded-lg"
          ref={ref}
        >
          <video
            ref={videoRef}
            key={inView ? "in-view" : "out-of-view"}
            className="h-auto w-full rounded-lg"
            src={videoUrl}
            controls
            controlsList="nodownload noplaybackrate"
            disablePictureInPicture
          />
        </div>
        <img src={spot1} className="absolute top-0 -right-4" alt="decoration" />
        <img src={spot2} className="absolute top-0 left-0" alt="decoration" />
        <img
          src={spot3}
          className="absolute bottom-0 -left-4"
          alt="decoration"
        />
      </div>
    </div>
  );
};
